import api from './api'

export default {
  getMe() {
    return api.get('/users/me')
  },
  updateMe(payload) {
    return api.put('/users/me', payload)
  },
  updatePassword(payload) {
    return api.put('/users/me/password', payload)
  }
}


